import { DafYomi } from '@hebcal/learning';
import { DailyLearning } from '@hebcal/core';
// Side-effect: importing @hebcal/learning registers all calendars into DailyLearning
import '@hebcal/learning';

/**
 * Metadata for all supported daily learning programs.
 * Used by LimudimWidget settings and display logic.
 */
export const LIMUDIM_PROGRAMS = [
  { key: 'dafYomi',                  he: 'דף יומי',              en: 'Daf Yomi',                 category: 'gemara' },
  { key: 'mishnaYomi',               he: 'משנה יומית',           en: 'Mishna Yomit',             category: 'mishna' },
  { key: 'nachYomi',                 he: 'נ"ך יומי',             en: 'Nach Yomi',                category: 'tanakh' },
  { key: 'rambam1',                  he: 'רמב"ם יומי',           en: 'Rambam 1',                 category: 'halacha' },
  { key: 'rambam3',                  he: 'רמב"ם ג\' פרקים',      en: 'Rambam 3',                 category: 'halacha' },
  { key: 'yerushalmi-vilna',         he: 'ירושלמי (וילנא)',       en: 'Yerushalmi Vilna',         category: 'gemara' },
  { key: 'yerushalmi-schottenstein', he: 'ירושלמי (שוטנשטיין)',   en: 'Yerushalmi Schottenstein', category: 'gemara' },
  { key: 'chofetzChaim',             he: 'חפץ חיים',             en: 'Chofetz Chaim',            category: 'mussar' },
  { key: 'shemiratHaLashon',         he: 'שמירת הלשון',          en: 'Shemirat HaLashon',        category: 'mussar' },
  { key: 'seferHaMitzvot',           he: 'ספר המצוות',           en: 'Sefer HaMitzvot',          category: 'halacha' },
  { key: 'kitzurShulchanAruch',      he: 'קיצור שולחן ערוך',     en: 'Kitzur Shulchan Aruch',    category: 'halacha' },
  { key: 'arukhHaShulchanYomi',      he: 'ערוך השולחן',          en: 'Arukh HaShulchan',         category: 'halacha' },
  { key: 'psalms',                   he: 'תהילים יומי',          en: 'Daily Psalms',             category: 'tanakh' },
  { key: 'tanakhYomi',               he: 'תנ"ך יומי',            en: 'Tanakh Yomi',              category: 'tanakh' },
  { key: 'pirkeiAvotSummer',         he: 'פרקי אבות',            en: 'Pirkei Avot',              category: 'mishna' },
  { key: 'perekYomi',                he: 'פרק יומי',             en: 'Perek Yomi',               category: 'mishna' },
  { key: 'dafWeekly',                he: 'דף שבועי',             en: 'Daf Weekly',               category: 'gemara' },
  { key: 'dirshuAmudYomi',           he: 'דירשו עמוד יומי',      en: 'Dirshu Amud Yomi',         category: 'gemara' },
];

/**
 * Get Daf Yomi for a given Hebrew date.
 *
 * @param {import('@hebcal/core').HDate} hdate
 * @returns {object} daf yomi data
 */
export function getDafYomiData(hdate) {
  try {
    const daf = new DafYomi(hdate);
    return {
      name: daf.render('he'),
      nameEn: daf.render('en'),
      tractate: daf.name,
      page: daf.blatt,
    };
  } catch {
    return null;
  }
}

/**
 * Get all daily learning programs for a given Hebrew date.
 * Uses DailyLearning.lookup() which returns pre-wrapped Event objects
 * with render('he'), render('en'), and url() methods.
 *
 * @param {import('@hebcal/core').HDate} hdate
 * @param {boolean} isIsrael
 * @returns {object} map of program key → { name, nameEn, url }
 */
export function getAllLimudimData(hdate, isIsrael) {
  const result = {};
  for (const prog of LIMUDIM_PROGRAMS) {
    try {
      const ev = DailyLearning.lookup(prog.key, hdate, isIsrael);
      if (ev) {
        result[prog.key] = {
          name: ev.render('he'),
          nameEn: ev.render('en'),
          url: typeof ev.url === 'function' ? ev.url() : null,
        };
      }
    } catch {
      // Skip programs that throw for dates before their start
    }
  }
  return result;
}
